import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { showError } from "../../utils/toastUtils";
import userAPI from "../../api/UserApi";
import { getDateAgo } from "../../helper/Helper";
import { ShoppingBag, Eye, ArrowRight } from "lucide-react";

const STATUS_MAP = {
  delivered:    { dot: "#2e7d32", color: "#2e7d32" },
  "in transit": { dot: "#e65100", color: "#e65100" },
  processing:   { dot: "#1565c0", color: "#1565c0" },
  cancelled:    { dot: "#c62828", color: "#c62828" },
  pending:      { dot: "#f57f17", color: "#f57f17" },
};

function Orders() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    fetchMyOrders();
  }, []);

  const fetchMyOrders = async () => {
    try {
      const res = await userAPI.fetchMyOrders();
      if (res.code === 200) {
        setOrders(res.data);
      }
    } catch (err) {
      showError(err.message);
    }
  };

  return (
    <div>
      <p className="vp-eyebrow">Your Purchases</p>
      <h2 className="vp-title">
        Order History{orders.length > 0 ? ` (${orders.length})` : ""}
      </h2>
      <div className="vp-rule" />

      {orders && orders.length > 0 ? (
        <div className="d-flex flex-column gap-3">
          {orders.map((order) => {
            const statusKey  = order.status?.toLowerCase();
            const statusMeta = STATUS_MAP[statusKey] || { dot: "#999", color: "var(--color-text-muted)" };

            return (
              <div key={order._id} className="vp-order">
                <div className="vp-order-info">
                  <p className="vp-order-id">
                    <Link
                      to="/users/order-details"
                      state={{ orderId: order._id }}
                    >
                      #{order.orderId}
                    </Link>
                  </p>
                  <p className="vp-order-date">{getDateAgo(order?.orderDate)}</p>
                  <p className="vp-order-amount">₹{order.total}/-</p>
                  <span
                    className="vp-order-status"
                    style={{ color: statusMeta.color }}
                  >
                    <span
                      className="vp-order-dot"
                      style={{ background: statusMeta.dot }}
                    />
                    {order.status.toUpperCase()}
                  </span>
                </div>
                <div className="vp-order-right">
                  <Link
                    to={`/users/order-details/${order.id}`}
                    className="vp-btn-ghost"
                  >
                    <Eye size={11} /> Detail
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="vp-empty">
          <ShoppingBag size={46} className="vp-empty-icon" />
          <p className="vp-empty-title">No orders yet</p>
          <p className="vp-empty-sub">
            You haven't placed any orders yet.
          </p>
          <Link to="/shop" className="vp-btn-primary">
            Shop Now <ArrowRight size={13} />
          </Link>
        </div>
      )}
    </div>
  );
}

export default Orders;